import { RadarChart, PolarGrid, PolarAngleAxis, Radar, ResponsiveContainer } from 'recharts';

function ScoreRing({ score, grade }) {
  const r = 54, cx = 64, cy = 64;
  const circumference = 2 * Math.PI * r;
  const dash = (score / 100) * circumference;
  return (
    <svg width={128} height={128} viewBox="0 0 128 128">
      <circle cx={cx} cy={cy} r={r} fill="none" stroke="var(--bg-surface)" strokeWidth={10} />
      <circle cx={cx} cy={cy} r={r} fill="none" stroke={grade.color} strokeWidth={10}
        strokeDasharray={`${dash} ${circumference}`} strokeLinecap="round"
        transform={`rotate(-90 ${cx} ${cy})`} style={{ transition: 'stroke-dasharray 0.6s' }} />
      <text x={cx} y={cy - 8} textAnchor="middle" fill={grade.color} fontSize={28} fontWeight={700} fontFamily="JetBrains Mono">{score}</text>
      <text x={cx} y={cy + 14} textAnchor="middle" fill="var(--text-secondary)" fontSize={11}>{grade.label}</text>
    </svg>
  );
}

function PillarBar({ label, value }) {
  const color = value >= 70 ? 'var(--green)' : value >= 50 ? 'var(--yellow)' : 'var(--red)';
  return (
    <div className="pillar-bar-row">
      <div className="pillar-bar-label">{label}</div>
      <div className="pillar-bar-track">
        <div className="pillar-bar-fill" style={{ width: `${value}%`, background: color }} />
      </div>
      <div className="pillar-bar-val">{value}</div>
    </div>
  );
}

export default function CompositeScore({ score }) {
  if (!score) return null;
  const { overall, grade, pillars } = score;
  const radarData = [
    { subject: 'Profit', value: pillars.profitability },
    { subject: 'Growth', value: pillars.growth },
    { subject: 'Balance', value: pillars.balanceSheet },
    { subject: 'FCF', value: pillars.fcfQuality },
    { subject: 'Momentum', value: pillars.momentum }
  ];
  return (
    <div className="card">
      <div className="card-title">Quality Score</div>
      <div style={{ display: 'flex', gap: 24, alignItems: 'center', flexWrap: 'wrap' }}>
        <ScoreRing score={overall} grade={grade} />
        <div style={{ flex: 1, minWidth: 200 }}>
          <PillarBar label="Profitability" value={pillars.profitability} />
          <PillarBar label="Growth" value={pillars.growth} />
          <PillarBar label="Balance Sheet" value={pillars.balanceSheet} />
          <PillarBar label="FCF Quality" value={pillars.fcfQuality} />
          <PillarBar label="Momentum" value={pillars.momentum} />
        </div>
        <div style={{ width: 200, height: 200 }}>
          <ResponsiveContainer>
            <RadarChart data={radarData}>
              <PolarGrid stroke="var(--border)" />
              <PolarAngleAxis dataKey="subject" tick={{ fill: 'var(--text-muted)', fontSize: 11 }} />
              <Radar dataKey="value" stroke="var(--accent)" fill="var(--accent)" fillOpacity={0.2} />
            </RadarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
